import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import moment from 'moment';
import { Tab, Tabs, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { getStatsLoading, getStatsLoaded } from '../../PipelineReducer';
import SizeGraph from '../size-graph';
import ConversionGraph from '../conversion-graph';
import BrenchmarkGraph from '../brenchmark-graph';
import VelocityGraph from '../velocity-graph';
import ProjectedGraph from '../projected-graph';
import styles from './styles.css';
import ProgressBar from '../../../../components/progress-bar';

class PipelineGraphs extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.onSelect = this.onSelect.bind(this);
  }
  componentDidMount() {
    this.props.onTabSelect(this.props.selectedTab);
  }

  onSelect(eventKey) {
    this.props.onTabSelect(eventKey);
  }

  render() {
    const { loading, loaded, query, pipelineDate, selectedTab } = this.props;

    const tips = {
      size: (
        <Tooltip id="pipline-size-chart-tip">
          <span>Analyze pipeline size, growth, age, distribution, and progress</span>
        </Tooltip>
      ),
      projected: (
        <Tooltip id="pipline-projected-chart-tip">
          <span>Analyze pipeline gaps based on sales goals</span>
        </Tooltip>
      ),
      velocity: (
        <Tooltip id="pipline-velocity-chart-tip">
          <span>Pipeline and sales stage velocity</span>
        </Tooltip>
      ),
      activity: (
        <Tooltip id="pipline-activity-chart-tip">
          <span>Opportunity activity</span>
        </Tooltip>
      ),
      conversion: (
        <Tooltip id="pipline-conversion-chart-tip">
          <span>Conversion rates, loss rates, and no decision rates by sales stage</span>
        </Tooltip>
      ),
      benchmark: (
        <Tooltip id="pipline-benchmark-chart-tip">
          <span>Compare pipeline sizes and conversion rates</span>
        </Tooltip>
      ),
    };

    const currentTab = selectedTab;
    // const currentTab = 'projected';

    return (
      <div className={`${styles.graphWrapper}`}>
        <div className="container">
          {(loading || !loaded) && <ProgressBar />}
          {!loading && loaded &&
            <div>
              <div>
                <Tabs
                  defaultActiveKey={currentTab}
                  id="outcome-tabs"
                  animation
                  mountOnEnter
                  unmountOnExit
                  onSelect={this.onSelect}
                >
                  <Tab
                    eventKey="size"
                    title={
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.size}>
                        <span>Size</span>
                      </OverlayTrigger>
                    }
                  >
                    <SizeGraph
                      onSelect={(ids) => {
                        this.props.onSelect(ids);
                      }}
                      pipelineDate={this.props.pipelineDate}
                    />
                  </Tab>
                  <Tab
                    eventKey="projected"
                    title={
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.projected}>
                        <span>Projected</span>
                      </OverlayTrigger>
                    }
                  >
                    <ProjectedGraph
                      pipelineDate={pipelineDate}
                      onSelect={(ids) => {
                        this.props.onSelect(ids, 'ProjectedGraph');
                      }}
                    />
                  </Tab>
                  <Tab
                    eventKey="velocity"
                    title={
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.velocity}>
                        <span>Velocity</span>
                      </OverlayTrigger>
                    }
                  >
                    <VelocityGraph
                      onSelect={(ids) => {
                        this.props.onSelect(ids, 'VelocityGraph');
                      }}
                    />
                  </Tab>
                  {false &&
                    <Tab
                      eventKey="activity"
                      title={
                        <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.activity}>
                          <span>Activity</span>
                        </OverlayTrigger>
                      }
                    >
                      <div><code>TODO: Activity</code></div>
                    </Tab>
                  }
                  <Tab
                    eventKey="conversion"
                    title={
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.conversion}>
                        <span>Conversion</span>
                      </OverlayTrigger>
                    }
                  >
                    <ConversionGraph
                      onSelect={(ids) => {
                        this.props.onSelect(ids, 'ConversionGraph');
                      }}
                      query={query}
                    />
                  </Tab>

                  <Tab
                    eventKey="benchmark"
                    title={
                      <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.benchmark}>
                        <span>Benchmark</span>
                      </OverlayTrigger>
                    }
                  >
                    <BrenchmarkGraph
                      onSelect={(ids) => {
                        this.props.onSelect(ids, 'BenchmarkGraph');
                      }}
                      query={query}
                    />
                  </Tab>

                  {false &&
                    <Tab
                      eventKey="scenarios"
                      title={
                        <OverlayTrigger trigger={['hover']} placement="top" overlay={tips.scenarios}>
                          <span>Scenarios</span>
                        </OverlayTrigger>
                      }
                    >
                      <div><code>TODO: Scenarios</code></div>
                    </Tab>
                  }
                </Tabs>
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    loading: getStatsLoading(state),
    loaded: getStatsLoaded(state),
  };
}

PipelineGraphs.propTypes = {
  loaded: PropTypes.bool,
  loading: PropTypes.bool,
  query: PropTypes.shape({}),
  onSelect: PropTypes.func,
  onTabSelect: PropTypes.func,
  selectedTab: PropTypes.string,
  pipelineDate: PropTypes.instanceOf(moment).isRequired,
};

PipelineGraphs.defaultProps = {
  loaded: false,
  loading: false,
  query: null,
  onSelect: () => {},
  onTabSelect: () => {},
  selectedTab: 'size',
};
PipelineGraphs.contextTypes = {
  router: PropTypes.object,
};
export default connect(mapStateToProps)(PipelineGraphs);
